import ApiCompanySite from 'types/api/CompanySite';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import  CompanySite from 'models/CompanySite';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {
    page?: number;
	perPage?: number;
    search?: string;
    jobCategorySlugs?: string[];
}
export const list = async (params?: ListParams): Promise<ListCollection<CompanySite>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicCompanySites, params),
        requestParams: params,
        cache: {
            enabled: false,
        },
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.CompanySites];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiCompanySite) => new CompanySite(element)),
        meta: resource.meta,
    };
};

export interface SingleParams {
    slug: string;
}
export const single = async (params: SingleParams): Promise<CompanySite> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicCompanySite, params),
        cache: {
            enabled: false,
        },
    });

    const data = response?.payload?.data;
    const resource: ApiCompanySite = data && data[ApiResources.CompanySite];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new CompanySite(resource);
};

export interface SinglePreviewParams {
    id: string;
}
export const singlePreview = async (params: SinglePreviewParams): Promise<CompanySite> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicCompanySitePreview, params),
        cache: {
            enabled: false,
        },
    });

    const data = response?.payload?.data;
    const resource: ApiCompanySite = data && data[ApiResources.CompanySite];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new CompanySite(resource);
};
export interface PublishParams {
    id: string;
    companyId: string;
    isPublished: boolean;
    description: string;
    bgImageId: string;
    logoId: string;
    employeesCount: string;
    jobCategoryId: string;
    instagramUrl: string;
    facebookUrl: string;
    linkedinUrl: string;
    websiteUrl: string;
    companyImages: {
        fileId: string;
    }[];
    companyDescriptions: null,
    companyAbouts: {
        id: string;
        description: string;
        type: string;
        title: string;
        order: number;
    }[],
    companyHistories: {
        id: string;
        description: string;
        type: string;
        title: string;
        order: number;
    }[],
    companyBenefits: {
        id: string;
        name: string;
    }[];
    stagesDescription: string;
}
export const publish = async (params: PublishParams): Promise<CompanySite> => {
    const response = await request({
        method: 'POST',
        path: withVariables(Endpoints.AdminCompanySitePublish, params),
        requestParams: params,
    }).catch((error) => {
        console.error(error);
        throw error;
    });

    const data = response?.payload?.data;
    const resource: ApiCompanySite = data && data[ApiResources.CompanySite];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return new CompanySite(resource);
};
